<h1 mat-dialog-title>Agregar Plantilla
    <mat-divider></mat-divider>
</h1>
<div mat-dialog-content>
    <form action="" [formGroup]="regOpcionForm" autocomplete="off" novalidate (ngSubmit)="guardarPlantilla()">
        <div class="row">
          <label for="plantillaOpcion" class="col-form-label text-sm-center col-md-3 col-12">Opciones:</label>
          <mat-form-field appearance="outline" class="col-md-9 col-sm-12">
            <mat-chip-list #chipList >
            <mat-chip *ngFor="let opcion of opciones" [selectable]="selectable"
              [removable]="removable" (removed)="remove(opcion)">
              {{opcion.descripcion}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
                  <input placeholder="Plantilla"
                    formControlName="plantillaOpcion"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="add($event)" [maxlength]="maxCaracteres" (input)="fnInputMaxLength($event);">
            </mat-chip-list>
            <mat-hint>Max. {{maxOpcionesPermitidas}} Opciones, dar ENTER para agregar.</mat-hint>
          </mat-form-field>
        </div>
        <div class="row mt-4 justify-content-center">
          <div class="col-sm-4 col-12">
              <button class="btn-block" mat-raised-button color="warn" aria-label="Clear" type="button" (click)='closeModal(false)'>
                <mat-icon>cancel</mat-icon>
                  Cancelar
              </button>
          </div>
          <div class="col-sm-4 col-12">
              <button class="btn-block" mat-raised-button color="primary" [disabled]="!validarPlantilla()" aria-label="Clear" type="submit">
                <mat-icon>save</mat-icon>
                  Guardar
              </button>
          </div>
        </div>
    </form>
</div>